<template>
    <th>
        <a href="#" @click.prevent="handle" class="inline-block">
            <div class="flex items-center">
                <slot></slot>
                <span v-show="sortBy === column && direction === 'asc'" class="px-1">
                    <img src="/images/icons/chevron-up.svg" width="16" height="16" style="min-width:1rem">
                </span>
                <span v-show="sortBy === column && direction === 'desc'" class="px-1">
                    <img src="/images/icons/chevron-down.svg" width="16" height="16" style="min-width:1rem">
                </span>
            </div>
        </a>
    </th>
</template>

<script>
    export default {
        props: ['sortBy', 'direction', 'column'],

        methods: {
            handle () {
                let direction = this.direction;

                if (this.sortBy === this.column && direction === 'asc') direction = 'desc';
                else if (this.sortBy === this.column && direction === 'desc') direction = 'asc';

                this.$emit('sort', {
                    column: this.sortBy,
                    direction: direction,
                });
            }
        }
    }
</script>